// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3I9W7","inner":"Form_inner__39zU-","range":"Form_range__2rcl4","name":"Form_name__2i16x","actions":"Form_actions__2yTyD"};